import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
const isFor = ['Dueños de gatos que viven en departamentos o espacios reducidos.', 'Personas que sufren de insomnio o irritabilidad por interrupciones del sueño.', 'Inquilinos que temen problemas con el consorcio por ruidos molestos.', 'Padres de gatos que quieren una solución ética y natural, sin fármacos.'];
const isNotFor = ['Personas que buscan una "pastilla mágica" para sedar a su mascota.', 'Dueños que no están dispuestos a dedicar 20 minutos de juego al llegar a casa.', 'Casos de gatos con patologías médicas graves (en ese caso, consultá a un vet).'];
export function ForNotFor() {
  return <section className="py-16 sm:py-24 bg-navy-light/30 border-y border-white/5" data-id="element-96">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-97">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-98">
          {/* Is For */}
          <div data-id="element-99">
            <FadeIn data-id="element-100">
              <h3 className="text-2xl sm:text-3xl font-bold mb-8 text-slate-100 flex items-center gap-3" data-id="element-101">
                <span className="bg-green-500/10 text-green-400 p-2 rounded-lg" data-id="element-102">
                  <CheckCircleIcon className="h-6 w-6" data-id="element-103" />
                </span>
                Esto es para vos si...
              </h3>
              <ul className="space-y-4" data-id="element-104">
                {isFor.map((item, index) => <li key={index} className="flex gap-3 text-slate-300 font-sans" data-id="element-105">
                    <CheckCircleIcon className="h-6 w-6 text-green-500/70 shrink-0" data-id="element-106" />
                    <span data-id="element-107">{item}</span>
                  </li>)}
              </ul>
            </FadeIn>
          </div>

          {/* Is Not For */}
          <div data-id="element-108">
            <FadeIn delay={0.2} data-id="element-109">
              <h3 className="text-2xl sm:text-3xl font-bold mb-8 text-slate-100 flex items-center gap-3" data-id="element-110">
                <span className="bg-red-500/10 text-red-400 p-2 rounded-lg" data-id="element-111">
                  <XCircleIcon className="h-6 w-6" data-id="element-112" />
                </span>
                Esto NO es para vos si...
              </h3>
              <ul className="space-y-4" data-id="element-113">
                {isNotFor.map((item, index) => <li key={index} className="flex gap-3 text-slate-400 font-sans" data-id="element-114">
                    <XCircleIcon className="h-6 w-6 text-red-500/50 shrink-0" data-id="element-115" />
                    <span data-id="element-116">{item}</span>
                  </li>)}
              </ul>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}